"use client";
import React, { Component } from "react";
import Slider from "react-slick";
import Image from "next/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Slide1 ,Slide2,Slide3,Slide4,Slide5,Slide6,Slide7,Slide8,Slide9,Slide10,Slide11,Slide12,Slide13,Slide14,Slide15} from "@/assets";
export default class CenterMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: 0,
    };
  }
  updateWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentDidMount() {
    // Set initial window width
    this.updateWindowWidth();

    // Add event listener for window resize
    window.addEventListener("resize", this.updateWindowWidth);
  }

  componentWillUnmount() {
    // Remove event listener when component is unmounted
    window.removeEventListener("resize", this.updateWindowWidth);
  }

  render() {
    const lefttorightsettings = {
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: true,
      speed: 8000,
      autoplaySpeed: 8000,
      cssEase: "linear",
      nextArrow: <></>,
      prevArrow: <></>,
      vertical: true,

      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 4000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            // dots: true,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            // dots: true,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            // dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1,
            // centerMode:true
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1,
            // centerMode:true
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1,
            // centerMode:true
          },
        },
      ],
    };
    const righttoleftsettings = {
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: -1,
      initialSlide: 0,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      vertical: true,
      cssEase: "linear",
      nextArrow: <></>,
      prevArrow: <></>,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 4000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: -1,
            infinite: true,
            // dots: true,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: -1,
            infinite: true,
            // dots: true,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: -1,
            infinite: true,
            // dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: -1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: -1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 2,
            slidesToScroll: -1,
            initialSlide: 1,
            // centerMode:true
          },
        },
      ],
    };

    return (
      <div className="flex md:h-[699px] gap-4 overflow-hidden">
        <div className="h-full">
          <Slider horizontal {...lefttorightsettings}>
            <div>
              <Image src={Slide1} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide2} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide3} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide4} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide5} alt="slider-book" className="max-w-full h-auto" />
            </div>
            {/* <div>
              <Image src={Book7} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book3} alt="slider-book" className="max-w-full h-auto" />
            </div> */}
          </Slider>
        </div>
        <div className=" ">
          <Slider horizontal {...righttoleftsettings}>
            <div>
              <Image src={Slide6} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide7} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide8} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide9} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide10} alt="slider-book" className="max-w-full h-auto" />
            </div>
          
          </Slider>
        </div>
        <div className="">
          <Slider horizontal {...lefttorightsettings}>
            <div>
              <Image src={Slide11} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide12} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide13} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide14} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Slide15} alt="slider-book" className="max-w-full h-auto" />
            </div>
          </Slider>
        </div>
        {/* <div className=" ">
          <Slider horizontal {...righttoleftsettings}>
            <div>
              <Image src={Book1} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book2} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book3} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book4} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book5} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book6} alt="slider-book" className="max-w-full h-auto" />
            </div>
            <div>
              <Image src={Book7} alt="slider-book" className="max-w-full h-auto" />
            </div>
          </Slider>
        </div> */}
      </div>
    );
  }
}
